/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AssessmentValidationResponseDataModel {
    getFixupPrototypeFunction() { return AssessmentValidationResponseDataModel.fixupPrototype; }

    static newInstance(model: Partial<AssessmentValidationResponseDataModel>): AssessmentValidationResponseDataModel {
        let obj = Object.assign(new AssessmentValidationResponseDataModel(), model);
        AssessmentValidationResponseDataModel.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AssessmentValidationResponseDataModel>): AssessmentValidationResponseDataModel {
        if (!model) return null;
        return AssessmentValidationResponseDataModel.newInstance(<AssessmentValidationResponseDataModel> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AssessmentValidationResponseDataModel) {
        if (!obj) return;

        models.AssessmentValidationResponseDataModel.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AssessmentValidationResponseDataModel): boolean {
        Object.setPrototypeOf(obj, AssessmentValidationResponseDataModel.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Assessment validation response for the cloud account based on the category
     */
    data: any;

}
